export interface LoginForm {
  username: string;
  password: string;
}

export interface Response<T = never> {
  message: string;
  code: number | string;
  data: T;
}

export interface MenuItem {
  id: string;
  name: string;
  icon: string;
  path?: string;
  children?: MenuItem[];
}

export interface BreadcrumbItem {
  name: string;
  path?: string;
}

export function isResponse(obj: any): obj is Response<any> {
  return typeof obj === 'object' && obj.message !== undefined && obj.code !== undefined;
}
